export default "__VITE_ASSET__a0d40be0__"